import {parse, TemplateChildNode} from '@vue/compiler-dom';
import {createTextVNode, createVNode, h, VNode} from 'vue';
import {NuxtLink} from '#components';

export default defineComponent({
  name: 'DynamicIntro',

  props: {
    html: {
      type: String as PropType<string>,
      required: true,
    },
    linkClass: {
      type: String as PropType<string>,
      default: '',
    },
  },

  // Inspired by the form handler in the Sofie nuxt layer
  setup(props, {attrs}) {
    function transformASTToVDom(node: TemplateChildNode): VNode | null {
      if (node.type === 2) { // Text node
        return createTextVNode(node.content);
      }

      if (node.type === 5) { // Interpolation node, due to similar syntax of {{link to=...}}
        if (node.content.type === 4) { // Simple expression, the "link to=..." segment will register as one
          const matches = node.content.content.match(/^link.*?\bto=['"]([^'"]+)['"].*?\btext=['"]([^'"]+)['"]/);

          if (matches) {
            return h(NuxtLink, {
              class: props.linkClass,
              to: {path: matches[1]},
            }, matches[2]);
          }
        }

        // When no valid matches are found, return the entire segment as a text node to preserve data.
        return createTextVNode(node.loc.source);
      }

      if (node.type !== 1) { // Element node
        return null;
      }

      const children = node.children.map(transformASTToVDom);
      const attrs = Object.fromEntries(
        node.props?.map(prop => [prop.name, prop.type === 6 ? prop.value?.content : undefined],
        ) ?? []);

      return createVNode(node.tag, attrs, children);
    }

    return () => h(
      'div',
      attrs,
      props.html
        ? parse(props.html, {
          whitespace: 'condense',
          onError: () => null,
        }).children.map(transformASTToVDom)
        : [],
    );
  },
});
